import { XIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

import { getSizeClasses, type ImageSize } from './square-image-upload.helper'

export interface SquareImageRemoveButtonProps {
  size: ImageSize
  removeTooltip: string
  onRemove: () => void
}

export const SquareImageRemoveButton = ({
  size,
  removeTooltip,
  onRemove,
}: SquareImageRemoveButtonProps): ReactNode => {
  const { removeButtonClass, removeIconClass } = getSizeClasses(size)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="secondary"
          size="icon"
          onClick={onRemove}
          className={cn(
            'square-image-upload-remove absolute -right-2 -top-2 rounded-full opacity-0 shadow-md',
            'transition-opacity group-hover:opacity-100',
            'hover:bg-destructive hover:text-destructive-foreground',
            removeButtonClass
          )}
          aria-label="Remove image"
        >
          <XIcon className={removeIconClass} />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">{removeTooltip}</TooltipContent>
    </Tooltip>
  )
}

SquareImageRemoveButton.displayName = 'SquareImageRemoveButton'
